// extracted by mini-css-extract-plugin
module.exports = {"payButtonsBox":"payButtons_payButtonsBox__EFxoM","payCommonButton":"payButtons_payCommonButton__YgCPM","payError":"payButtons_payError__VaUxb"};